// extracted by mini-css-extract-plugin
module.exports = {"title":"system-error_title_2chjn"};